import User from "../../entity/user"
import { Role } from "../../entity/user"
import { Signup } from "../../entity/signup"
import * as types from "./mutation_types"

const actions = {
  async getUserInfo({ commit, state }) {
    // commit(types.CUREENT_USER_GET_ERROR, null);
    if (state.isCurrentUserFetched != null) {
      await state.isCurrentUserFetched
      return state.currentUser
    } else {
      const waitableFetch = new Promise((resolve) => {
        this.currentUserResolver = resolve
      })
      commit("setCurrentUserFetchPromise", waitableFetch)
      return User.getCurrentUser()
        .then((user) => {
          this.currentUserResolver(true)
          commit(types.CURRENT_USER_UPDATE, user)
          return user
        })
        .catch(() => {
          commit(types.CUREENT_USER_GET_ERROR, "failed to fetch current user")
          return new User()
        })
    }
  },
  // getUserInfo({ commit, state }) {
  //   // commit(types.CUREENT_USER_GET_ERROR, null);
  //   console.log("state.currentUserFetched")
  //   onsole.log(state.currentUserFetched)
  //   if (state.currentUserFetched) {
  //     return Promise.resolve(state.currentUser)
  //   } else {
  //     return User.getCurrentUser()
  //       .then((user) => {
  //         console.log("!!!!!!!!!")
  //         console.log(user)
  //         commit(types.CURRENT_USER_UPDATE, user)
  //         return user
  //       })
  //       .catch(() => {
  //         commit(types.CUREENT_USER_GET_ERROR, "failed to fetch current user")
  //         return new User()
  //       })
  //   }
  // },

  async getSignupInfo({ commit, state }, params) {
    // commit(types.CUREENT_USER_GET_ERROR, null);    
    if (state.isCurrentSignupFetched != null) {
      await state.isCurrentSignupFetched
      return state.signup
    } else {
      const waitableFetch = new Promise((resolve) => {
        this.currentSignupeResolver = resolve
      })
      commit("setSignupFetchPromise", waitableFetch)

      const conference_id = params.id
      const url =
        process.env.VUE_APP_API_URL +
        `api/v1/conference/${conference_id}/signup/user`
      const res = await axios.get(url)
      let signup = null
      if(res.data.data!=null){
        signup = Object.assign({}, res.data.data)
      }else{
        signup = new Signup()
      }
      commit(types.CURRENT_SIGNUP_UPDATE, signup)
      this.currentSignupeResolver(true)
      return signup
    }
  },

  getUserList({ commit, state }) {
    // commit(types.CUREENT_USER_GET_ERROR, null);
    if (state.userList !== null && state.userList.length > 0) {
      return Promise.resolve(state.userList)
    } else {
      if (state.isfetchUserList) {
        return Promise.resolve(state.userList)
      } else {
        commit("isfetchUserListLock", true)
        return User.getAllUsers()
          .then((userlist) => {
            const list = userlist
              .filter((x) => x.type != "A")
              .sort((a, b) => a.username - b.username)
            commit(types.CURRENT_USER_List_UPDATE, list)
            commit("isfetchUserListLock", false)
            return userlist
          })
          .catch(() => {
            commit(types.CURRENT_USER_List_ERROR, "failed to fetch user list")
            commit("isfetchUserListLock", false)
            return new Array()
          })
      }
    }
  },

  getUserRoles({ commit }) {
    // commit(types.CUREENT_USER_GET_ERROR, null);
    if (state.userRolesFetched) {
      return Promise.resolve(state.userRoles)
    } else {
      return Role.getUserRoles()
        .then((roles) => {
          commit(types.CURRENT_ROLES_UPDATE, roles)
          return roles
        })
        .catch(() => {
          commit(types.CUREENT_ROLES_GET_ERROR, "failed to fetch user roles")
          return new Array()
        })
    }
  },

  async resetFetchSignupInfo({ commit, state, dispatch, rootState }) {
    // 重置当前signup状态
    commit("setSignupFetchPromise", null)
    // const phone = state.signup.phone
    // const conference_id = state.signup.conference_id
    // console.log("reset")
    // console.log(state.currentUser.username)
    // console.log(rootState.conference.currentConference.id)
    commit(types.CURRENT_SIGNUP_UPDATE, new Signup())
    const signup = await dispatch("getSignupInfo", {
      username: state.currentUser.username,
      id: rootState.conference.currentConference.id,
    })
    return signup
  },
}

function initialState() {
  return {
    // currentUser: new User(),
    currentUser: {},
    isCurrentUserFetched: null,
    userList: new Array(),
    isfetchUserList: false,
    userRoles: new Array(),
    userRolesFetched: false,
    signup: new Signup(),
    isCurrentSignupFetched:null
  }
}

const state = initialState()

const getters = {}

const mutations = {
  setCurrentUserFetchPromise(state, waitableFetch) {
    state.isCurrentUserFetched = waitableFetch
  },
  //关于报名信息
  setSignupFetchPromise(state, waitableFetch) {
    state.isCurrentSignupFetched = waitableFetch
  },
  [types.CURRENT_SIGNUP_UPDATE](state, signup) {
    state.signup = signup;
  },
  [types.CUREENT_SIGNUP_GET_ERROR](state) {
    state.signup = null;
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },


  [types.CURRENT_USER_UPDATE](state, userInfo) {
    state.currentUserFetched = true
    state.currentUser = {...state.currentUser, ...userInfo}
  },
  [types.CURRENT_USER_RESET](state) {
    state.currentUser = null
    state.currentUserFetched = false
    const s = initialState()
    Object.keys(s).forEach((key) => {
      state[key] = s[key]
    })
  },
  [types.CUREENT_USER_GET_ERROR](state) {
    state.currentUser = null
    const s = initialState()
    Object.keys(s).forEach((key) => {
      state[key] = s[key]
    })
  },
  [types.CURRENT_USER_List_UPDATE](state, userlist) {
		state.userList.splice(0, state.userList.length)
		state.userList = [...userlist]
    // for (const user of userlist) {
    //   state.userList.push(user);
    // }
  },
  isfetchUserListLock(state, status) {
    state.isfetchUserList = status
  },

  [types.CURRENT_USER_List_RESET](state) {
    state.userList.splice(0, state.userList.length)
  },
  [types.CURRENT_USER_List_ERROR](state) {
    state.userList = null
  },
  [types.CURRENT_ROLES_UPDATE](state, roles) {
    state.userRolesFetched = true
    state.userRoles.splice(0, state.userRoles.length)
    for (const role of roles) {
      state.userRoles.push(role)
    }
  },
  [types.CUREENT_ROLES_GET_ERROR](state) {
    state.userRoles = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
